// extracted by css-extract-rspack-plugin
export default {"contentsWrap":"PersonalResultDetail__contentsWrap--gjhbA","select":"PersonalResultDetail__select--J_0O_"};